<template>
	<div class="url-result">
        <input 
            type="text" 
            class="result" 
            @focus="$event.target.select()" 
            :value="value" 
            :disabled="isEmpty"
            :placeholder="placeholder"
            ref="urlInput" 
            readonly
        >
        <a @click="copyUrl" class="copy-button" href="javascript:;">
            <img :src="icon" alt="Copy Button">
        </a>
	</div>

</template>

<script>

const ICON_COPY = '/svg/copy.svg';
const ICON_CHECK = '/svg/check.svg';

export default {
    props: {
        value: String,
        placeholder: String,
	},
    data() {
        return {
            icon: ICON_COPY
        }
    },
	methods: {
        copyUrl() {
            var copyText = this.$refs.urlInput;
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(copyText.value);

            this.icon = ICON_CHECK;

            setTimeout(() => {
                this.icon = ICON_COPY;
                document.getSelection().removeAllRanges();
            }, 3000);
        }
    },
    computed: {
        isEmpty() {
            return !this.value || this.value.length == 0;
        }
    }
};
</script>
